module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-00-c3fdd2a1a486c9aa2e252af073f80c1d.svg";